import { GeneralConfigurationItemEnricher } from './configurationItemEnricher';
import { ConfigurationEnricher } from './model';

export const SpecificItemEnricher: ConfigurationEnricher = {
  shouldEnrich: (_, __) => true,
  enrich: (configuration, context) => {
    configuration.forEach((field) => {
      GeneralConfigurationItemEnricher.enrich(field, context);
    });
  },
};
